// import type { ThemeConfig } from "antd";
const AntdConfig = {
  token: {
    fontFamily: 'IBM Plex Sans Devanagari',

    colorPrimary: '#ED1C24',
    // colorPrimary: "#EE1A29",
    // colorSuccess: "rgb(0, 132, 61)",
    colorError: '#EE1A29',
    // colorWarning:"rgb(252, 227, 0)"
  },
  components: {
    Spin: {
      colorPrimary: '#ED1C24',
    },
    Layout: {
      headerBg: 'white',
      headerPadding: '0 20px',
      headerHeight: 66,
      bodyBg: 'transparent',
    },
    Typography: {
      colorTextHeading: '#ED1C24',
      colorText: '#ED1C24',
    },
    Radio: {
      colorPrimary: '#ED1C24',
      radioSize: 12,
      fontSize: 12,
      dotSize: 8,
      wireframe: true,
    },
    Button: {
      borderRadius: 10,
      padding: '0 20px', // This replaces paddingInline with padding
      controlHeight: 30,
      lineHeight: 1.8,
      fontSize: 14,
      colorBorder: '#EE1A29',
      colorPrimary: '#EE1A29',
      primaryColor: '#fff',
      colorPrimaryBorder: '#EE1A29',
      colorPrimaryHover: '#a31319',
      colorPrimaryActive: '#a31319',
      primaryShadow: 'none',

      defaultBg: '#fff',
      defaultBorderColor: '#EE1A29',
      defaultColor: '#EE1A29',
      defaultActiveBg: '#a31319',
      defaultActiveColor: '#ffffff',
      defaultHoverColor: '#ffffff',
      defaultHoverBg: '#a31319',
      defaultHoverBorderColor: '#a31319',
      borderColorDisabled: '#d9d9d9',

      colorLink: '#EE1A29',
      colorLinkActive: '#EE1A29',
      colorLinkHover: '#a31319',
    },
    Input: {
      borderRadius: 5,
      borderRadiusSM: 5,
      borderRadiusLG: 5,
      controlHeight: 30,
      controlHeightSM: 30,
      controlHeightLG: 30,
      fontSize: 12,
      colorBorder: '#E6E6E6',
      hoverBorderColor: '#707C8B',
      activeShadow: '0 0 0 2px rgba(5, 145, 255, 0.1)',
      fontSizeIcon: 20,
      colorIcon: '#0C4DA1',
    },
    Tag: {
      borderRadiusSM: 2,
      fontSize: 14,
      colorWarning: 'rgb(232, 111, 37)',
      colorWarningBorder: '#FFBB96',
      colorWarningBg: 'rgb(254, 241, 225)',

      colorInfo: 'rgb(44, 92, 197)',
      colorInfoBorder: 'rgb(44, 92, 197)',
      colorInfoBg: 'rgb(229, 242, 253)',
    },
    Table: {
      borderRadius: 0,
      borderRadiusLG: 0,
      colorBgContainer: '#ffffff',
      fontWeightStrong: 500,
      paddingContentVertical: 14,
      colorBorderSecondary: '#DFE0E2',
      colorText: 'rgba(0, 0, 0, 0.65)',
      cellPaddingBlock: 10,
      cellFontSize: 14,
      headerBg: '#0C4DA1',
      headerColor: '#FFFFFF',
      headerSortHoverBg: '#EE1A29',
      headerSortActiveBg: '#EE1A29',

      headerSplitColor: 'rgb(44, 92, 197)',
      // "rowHoverBg": "rgb(82, 196, 26)",
    },

    Menu: {
      borderRadius: 0,
      radiusItem: 0,
      // dropdownWidth: 160,
      itemBorderRadius: 2,
      radiusSubMenuItem: 0,
      subMenuItemBorderRadius: 0,
      itemColor: 'rgba(0, 0, 0, 0.85)',
      itemSelectedColor: '#1890FF',
      margin: 0,
      fontSize: 14,
      itemHeight: 45,

      // colorBgContainer: "#ffffff",
    },
    Cascader: {
      controlItemBgActive: '#e6f4ff',
      borderRadiusSM: 2,
      fontSizeIcon: 12,
    },
    Checkbox: {
      colorPrimaryTextHover: '#0C4DA1',
    },
    Collapse: {
      headerBg: 'rgba(255, 255, 255, 0.02)',
      colorText: 'rgb(97, 97, 97)',
      colorTextHeading: 'rgb(51, 51, 51)',
      colorBorder: 'rgba(0,0,0,0)',
    },
    Slider: {
      trackBg: 'rgb(236, 33, 39)',
      railBg: '#FFDEDE',
      railHoverBg: 'rgb(236, 33, 39)',
      colorBgElevated: 'rgb(25,135,84)',
      handleColor: 'rgb(255, 255, 255)',
      handleActiveColor: 'rgb(255, 255, 255)',
      trackHoverBg: 'rgb(236, 33, 39)',
      dotActiveBorderColor: 'rgb(255, 255, 255)',
      colorPrimaryBorderHover: 'rgb(255, 255, 255)',
    },

    InputNumber: {
      borderRadius: 5,
      borderRadiusSM: 5,
      borderRadiusLG: 5,
      controlHeight: 30,
      controlHeightSM: 30,
      controlHeightLG: 30,
      fontSize: 12,
      colorBorder: '#E6E6E6',
      // hoverBg: "rgba(255, 255, 255, 0)",
      handleHoverColor: 'rgba(22, 119, 255, 0)',
      activeBorderColor: '#0C4DA1',
      hoverBorderColor: '#707C8B',
      colorPrimary: 'rgb(217, 217, 217)',
      addonBg: 'rgb(255, 255, 255)',
    },
    Select: {
      borderRadius: 5,
      colorPrimary: 'rgb(51, 51, 51)',
      colorPrimaryHover: 'rgba(51, 51, 51, 0.7)',
      controlOutline: '#919599',
      controlOutlineWidth: 0,
      singleItemHeightLG: 30,
      singleItemHeightSM: 30,
      singleItemHeight: 30,
      multipleItemHeight: 30,
      borderRadiusLG: 5,
      borderRadiusSM: 5,
      borderRadiusXS: 5,
      optionSelectedColor: '#ffffff',
      colorText: '#161616',
      optionSelectedBg: '#0C4DA1',
      controlHeight: 30,
      controlHeightSM: 30,
      optionSelectedFontWeight: 500,
      colorBorder: '#E6E6E6',
      hoverBorderColor: '#0C4DA1',
      optionFontSize: 12,
      fontSize:12
    },
    Drawer: {
      colorBgMask: 'rgba(0,0,0,0.45)',
      padding: 15,
      paddingLG: 15,
      paddingXS: 15,
      colorBgElevated: '#0C4DA1',
      colorText: 'rgb(255,255,255)',
    },
    Pagination: {
      colorPrimary: '#EE1A29',
      fontWeightStrong: 700,
      colorPrimaryHover: '#EE1A29',
      colorBgTextActive: '#EE1A29',
    },
    Dropdown: {
      borderRadius: 5,
    },
    Form: {
      labelFontSize: 13,
      labelHeight: 'auto',
      itemMarginBottom: 0,
      verticalLabelPadding:0
    },
    DatePicker: {
      controlHeight: 30,
    },
    Divider: {
      margin: 8
    },
    Steps: {
      lineWidth: 10,
      colorPrimary: '#EE1A29',
      iconSize: 60,
      customIconSize: 60,
      //  fontSize: 20,
      iconFontSize: 20,
      lineHeight: 2,
    },
  },
}

export default AntdConfig
